import axios from 'axios';

export async function loadSchema(uri: string) {
    try {
        return (await axios.get(uri)).data;
    } catch (e) {
        throw new Error(`Failed to load data from ${uri}`);
    }
}
